/* eslint-disable no-unused-vars */
import axios from "axios";
import moment from "moment"
import _ from "lodash"
import { apiServerUrl } from '../../../config/config.json';
import { custom } from "joi";

const route_url = `${apiServerUrl}/routes`;
const documents_url = `${apiServerUrl}/documents`;


export default ({
    async fetchForRoutes({ commit }) {
        try {
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(`${documents_url}/initiate/pending`, {
                headers: { 'x-drmms-token': authToken }
            });
            commit('set_for_routes_count', response.data.length)
        } catch (error) {
            console.error(error)
        }
    },
    async fetchRouteInProgress({commit}){
        try {
            const query = {
                "$route.status$" : { "$eq": "Pending"}
            }
            const q = encodeURIComponent(JSON.stringify(query,null,4));
            const customUrl = route_url + '?limit=' + 0 + '&query='+ q ;
            
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(customUrl, {
                headers: { 'x-drmms-token': authToken }
            });

            const count = _.get(response,"data.count",0)
            commit('set_routes_in_progress_count',count)
        } catch (error) {
            console.error(error)
        }
    },
    async fetchRouteThatAreDueIn({commit},days){
        try {
            const query = {
                "$route.datetime_due$" : { 
                    "$lte": moment().format("YYYY-MM-DD HH:mm:ss"),
                    "$gte": moment().subtract(days, 'days').format("YYYY-MM-DD HH:mm:ss"),
                }
            }
            console.log( moment().subtract(days, 'days').format("YYYY-MM-DD HH:mm:ss"))
            const q = encodeURIComponent(JSON.stringify(query,null,4));
            const customUrl = route_url + '?limit=' + 0 + '&query='+ q ;
            console.log('url',customUrl)
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(customUrl, {
                headers: { 'x-drmms-token': authToken }
            });
            console.log(response.data)
            return response.data.count
        } catch (error) {
            return 0
        }
    },
    async fetchOverDueRoutes(){
        try {
            const query = {
                "$route.overdue_status$" : { "$eq": "1"}
            }
            const q = encodeURIComponent(JSON.stringify(query,null,4));
            const customUrl = route_url + '?limit=' + 0 + '&query='+ q ;
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(customUrl, {
                headers: { 'x-drmms-token': authToken }
            });
            console.log(response.data)
            return response.data.count
        } catch (error) {
            return 0
        }
    },
    async fetchIdleRoutes(){
        try {
            const query = {
                "$route.updatedAt": {"$gte":moment().subtract(1, 'days').format("YYYY-MM-DD HH:mm:ss")},
                "$route.status$" : { "$eq": "Pending"}
            }   
            const q = encodeURIComponent(JSON.stringify(query,null,4));
            const customUrl = route_url + '?limit=' + 0 + '&query='+ q ;
            
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(customUrl, {
                headers: { 'x-drmms-token': authToken }
            });
            return response.data.length
        } catch (error) {
            return 0
        }
    },
    async fetchDocumentByCategory({commit},category){
        try {
            const query = {
                "$document_category.name$" : {"$like":  category}
            }
            // MyModel.count({
            //     include: ...,
            //     where: ...,
            //     distinct: true,
            //     col: 'Product.id'
            //   })
            //   .then(function(count) {
            //       // count is an integer
            //   });
            const q = encodeURIComponent(JSON.stringify(query,null,4));
            const customUrl = documents_url + '?limit=' + 0 + '&query='+ q ;
     
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(customUrl, {
                headers: { 'x-drmms-token': authToken }
            });
            
            return response.data.count
        } catch (error) {
            console.log(error)
        }
    },
    async fetchTopCategories({commit}, category){
		// initially, parameter was "limit" but since it wasn't used, changed it back to category
        try {
            const query = {
                "$document_category.name$" : {"$like":  category}
            }
            const q = encodeURIComponent(JSON.stringify(query,null,4));
            const customUrl = documents_url + '?limit=' + 0 + '&query='+ q ;
            console.log(customUrl)
            const authToken = localStorage.getItem('access_token');
            const response = await axios.get(customUrl, {
                headers: { 'x-drmms-token': authToken }
            });
            
            return response.data.count
        } catch (error) {
            console.log(error)
        }
    }
})